<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/avignonesi')">Avignonesi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri')">Azienda
                        Agricola Casanova di Neri
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-salvioni')">Azienda Salvioni
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/tuscany/castiglione-del-bosco')">Castiglione del Bosco
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/conti-constani')">Conti Constani
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-le-pupille')">Fattoria Le Pupille
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-poggio-di-sotto')">Fattoria Poggio di
                        Sotto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fontodi')">Fontodi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/frescobaldi')">Frescobaldi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/gianfranco-soldera')">Gianfranco Soldera
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/isole-e-olena')">Isole e Olena
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/marchesi-antinori')">Marchesi Antinori
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/podere-poggio-scalette')">Podere Poggio
                        Scalette
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/poderi-boscarelli')">Poderi Boscarelli
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/rocca-di-frassinello')">Rocca di Frassinello
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-dell-ornellaia')">Tenuta dell’Ornellaia
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-di-trinoro')">Tenuta di Trinoro
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-san-guido')">Tenuta San Guido
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Castiglione del Bosco</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Castiglione del Bosco è un vigneto sexy. Incastonato in un Patrimonio dell'Umanità UNESCO, di proprietà di Massimo Ferragamo (sì, come in quel Ferragamo) e parte del prestigioso gruppo alberghiero Rosewood,
                        se dovessi mai descrivere come dovrebbe apparire un vigneto toscano, probabilmente lo faresti descrivendo
                        Castiglione del Bosco.
                    </div>

                    <div class="howto-title2">Uno dei famosi cinque super-toscani originali</div>
                    <div class="howto-text">
                        Ma credenziali di lusso a parte, Castiglione del Bosco è prima di tutto una cantina e un jolly
                        bravo in questo. Situata a nord-ovest di Montalcino, la cantina è una delle più antiche in
                        Toscana, anche se una delle meno commerciali. Infatti, nonostante la sua vinificazione molto ricca
                        storia, ha iniziato a produrre vini solo negli anni '50. La tenuta divenne anche uno dei
                        padri fondatori del Consorzio del Vino Brunello di Montalcino - l'organo di governo che
                        regola e controlla la qualità della produzione del Brunello - nel 1967. Un enorme 2000 ettari
                        in totale, “appena” 62 di questi sono destinati a vigneto (a conduzione biologica), impiantati
                        esclusivamente con Sangiovese. La miscelazione è supervisionata dallo straordinario maestro di cantina Nicolò
                        D'Afflitto e Cecilia Leoneschi, enologa di formazione locale. Sotto la loro attenta direzione,
                        Castiglione del Bosco ha cominciato ad attirare un'attenzione critica che smentisce di gran lunga la sua seducente
                        credenziali; è diventata una cantina da non sottovalutare.
                    </div>

                    <div class="howto-title2">Ma per quanto riguarda il vino?</div>
                    <div class="howto-text">
                        Con così tanti ettari di vigneto, Castiglione del Bosco non sorprende che ne produca parecchi
                        vini: quattro rossi e un bianco, e il loro San Michele. Concentrandosi qui sul
                        Consorzio del Vino Brunello di Monatalcino - un vino a cinque stelle di James Suckling (e solo il
                        settimo cinque stelle dal 1990), ha definito il 2012 “preciso e bello” per uno straordinario 96
                        punti. Sorprendentemente un buon rapporto qualità-prezzo, questa potrebbe essere una gradita aggiunta a qualsiasi vino
                        portafoglio dell'invertitore. L'edizione limitata 2010 Zodiac Monkey ha mantenuto costante il suo prezzo
                        Circa 500 euro a bottiglia, ma collezionisti e investitori prendono nota: questa è una bottiglia incredibilmente dura
                        da trovare, quindi se riesci a trovarne uno, la scarsità è destinata a riflettere il mercato secondario del vino
                        valore al dettaglio.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Castiglione del Bosco</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Castiglione del Bosco ist ein sexy Weinberg. In einem UNESCO-Weltkulturerbe gelegen, im Besitz von Massimo Ferragamo (ja, wie in diesem Ferragamo) und Teil der prestigeträchtigen Rosewood-Hotelgruppe,
                        Wenn Sie jemals beschreiben müssten, wie ein toskanischer Weinberg aussehen sollte, würden Sie wahrscheinlich beschreiben
                        Castiglione del Bosco.
                    </div>

                    <div class="howto-title2">Einer der ursprünglich berühmten fünf Supertoskaner</div>
                    <div class="howto-text">
                        Abgesehen von seinem Luxusanspruch ist Castiglione del Bosco in erster Linie ein Weingut und ein fröhliches Lokal
                        Guter noch dazu. Das im Nordwesten von Montalcino gelegene Weingut ist eines der ältesten in
                        Die Toskana ist zwar eine der am wenigsten kommerziellen. Tatsächlich trotz seiner sehr reichhaltigen Weinbereitung
                        Geschichte, es begann erst in den 1950er Jahren mit der Weinproduktion. Das Anwesen wurde auch eines der
                        Gründerväter des Consorzio del Vino Brunello di Montalcino – dem Leitungsgremium, das
                        regelt und kontrolliert die Qualität der Brunello-Produktion – im Jahr 1967. Riesige 2.000 Hektar
                        insgesamt werden „nur“ 62 davon in (biologische) Weinberge überführt und bepflanzt
                        ausschließlich mit Sangiovese. Das Mischen wird von dem außergewöhnlichen Kellermeister Nicolo überwacht
                        D’Afflitto und die vor Ort ausgebildete Önologin Cecilia Leoneschi. Unter ihrer sorgfältigen Leitung
                        Castiglione del Bosco hat begonnen, die Aufmerksamkeit der Kritiker auf sich zu ziehen, die seine Verführungskraft bei weitem nicht wahrnimmt
                        Referenzen; Es hat sich zu einem Weingut entwickelt, mit dem man rechnen kann.
                    </div>

                    <div class="howto-title2">Aber was ist mit dem Wein?</div>
                    <div class="howto-text">
                        Es überrascht nicht, dass Castiglione del Bosco bei so vielen Hektar Weinbergen ziemlich viel produziert
                        Weine: nämlich vier Rotweine und ein Weißwein sowie deren San Michele. Ich konzentriere mich hier auf die
                        Consorzio del Vino Brunello di Monatalcino – ein Fünf-Sterne-Wein von James Suckling (und nur der
                        (siebter Fünf-Sterne-Stern seit 1990) bezeichnete er das Jahr 2012 als „präzise und schön“ für atemberaubende 96
                        Punkte. Er bietet ein überraschend gutes Preis-Leistungs-Verhältnis und könnte eine willkommene Ergänzung zu jedem Wein sein
                        Portfolio des Anlegers. Die limitierte Auflage des Zodiac Monkey 2010 hat ihren Preis stabil gehalten
                        Ungefähr 500 € pro Flasche, aber Sammler und Investoren aufgepasst: Dies ist eine unglaublich harte Flasche
                        Wenn Sie also einen finden können, spiegelt die Knappheit zwangsläufig den Sekundärmarkt des Weins wider
                        Verkaufswert.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Castiglione del Bosco</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Castiglione del Bosco est un vignoble sexy. Situé dans un site du patrimoine mondial de l'UNESCO, propriété de Massimo Ferragamo (oui, comme dans ce Ferragamo) et faisant partie du prestigieux groupe hôtelier Rosewood,
                        si jamais vous deviez décrire à quoi devrait ressembler un vignoble toscan, vous décririez probablement
                        Castiglione del Bosco.
                    </div>

                    <div class="howto-title2">L'un des cinq célèbres super-toscans d'origine</div>
                    <div class="howto-text">
                        Mais au-delà des références de luxe, Castiglione del Bosco est avant tout une cave et un joyeux
                        bon à ça. Située au nord-ouest de Montalcino, la cave est l'une des plus anciennes de
                        La Toscane, bien que l'une des moins commerciales. En effet, malgré sa très riche vinification
                        histoire, elle n'a commencé à produire des vins que dans les années 1950. Le domaine est également devenu l'un des
                        pères fondateurs du Consorzio del Vino Brunello di Montalcino - l'organe directeur qui
                        réglemente et contrôle la qualité de la production de Brunello - en 1967. Un énorme 2 000 hectares
                        au total, "seulement" 62 d'entre elles sont consacrées à des vignobles (en agriculture biologique), plantés
                        exclusivement avec du Sangiovese. L'assemblage est supervisé par l'extraordinaire maître de chais Nicolo
                        D'Afflitto et l'œnologue de formation locale Cecilia Leoneschi. Sous leur direction prudente,
                        Castiglione del Bosco a commencé à attirer une attention critique qui dément bien sa séduisante
                        crédits; c'est devenu une cave avec laquelle il faut compter.
                    </div>

                    <div class="howto-title2">Mais qu'en est-il du vin?</div>
                    <div class="howto-text">
                        Avec autant d'hectares de vignes, Castiglione del Bosco produit sans surprise pas mal de
                        vins: à savoir quatre rouges et un blanc, et leur San Michele. Se concentrant ici sur la
                        Consorzio del Vino Brunello di Monatalcino - un vin cinq étoiles de James Suckling (et seul le
                        septième cinq étoiles depuis 1990), il a qualifié le 2012 de "précis et beau" pour un superbe 96
                        points. Étonnamment bon rapport qualité-prix, cela pourrait être un ajout bienvenu à n'importe quel vin
                        portefeuille de l'investisseur. L'édition limitée 2010 Zodiac Monkey a maintenu son prix à un niveau stable
                        Environ 500 € la bouteille, mais collectionneurs et investisseurs prennent note : c'est une bouteille incroyablement dure
                        à trouver, donc si vous pouvez en trouver un, la rareté reflètera forcément le marché secondaire du vin
                        La valeur au détail.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Castiglione del Bosco</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Castiglione del Bosco is one sexy vineyard. Set in a UNESCO World Heritage Site, owned by Massimo Ferragamo (yes, as in that Ferragamo) and part of the prestigious Rosewood hotel group,
                        if you ever had to describe how a Tuscan vineyard should look, you’d probably be describing
                        Castiglione del Bosco.
                    </div>

                    <div class="howto-title2">One of the original famous five super-Tuscans</div>
                    <div class="howto-text">
                        But luxury credentials aside, Castiglione del Bosco is first and foremost a winery and a jolly
                        good one at that. Located in the northwest of Montalcino, the winery is one of the oldest in
                        Tuscany, although one of the least commercial. In fact, despite its very rich winemaking
                        history, it only started producing wines in the 1950s. The estate also became one of the
                        founding fathers of the Consorzio del Vino Brunello di Montalcino - the governing body that
                        regulates and controls the quality of Brunello production - in 1967. An enormous 2,000-hectares
                        in total, “just” 62 of these are given over to (organically farmed) vineyards, planted
                        exclusively with Sangiovese. Blending is overseen by cellar master extraordinaire Nicolo
                        D’Afflitto and locally trained oenologist Cecilia Leoneschi. Under their careful direction,
                        Castiglione del Bosco has begun to attract critical attention that far belies its seductive
                        credentials; it has become a winery worth reckoning with.
                    </div>

                    <div class="howto-title2">But what about the wine?</div>
                    <div class="howto-text">
                        With so many hectares of vineyard, Castiglione del Bosco unsurprisingly produce quite a few
                        wines: namely four reds and one white, and their San Michele. Concentrating here on the
                        Consorzio del Vino Brunello di Monatalcino - a five-star wine from James Suckling (and only the
                        seventh five star since 1990), he called the 2012 “precise and beautiful” for a stunning 96
                        points. Surprisingly good value for money, this could be a welcome addition to any wine
                        inverstor’s portfolio. The limited edition 2010 Zodiac Monkey has held its price at a steady
                        €500 or so per bottle, but collectors and investors take note: this is an incredibly hard bottle
                        to find, so if you can find one, the scarcity is bound to reflect the wine’s secondary market
                        retail value.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CastiglioneDelBosco",
    head: {
        title: 'Castiglione del Bosco | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional wines of Castiglione del Bosco, a renowned wine producer in Tuscany. Their unique blend of traditional and innovative techniques creates a distinctive flavor profile for their wines. Savor the rich heritage of this wine producer and taste the beauty of Tuscany in every sip.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Castiglione del Bosco', src: '/wine-guide/italy/tuscany/castiglione-del-bosco'},
            items: [
                {report: 'Avignonesi', src: '/wine-guide/italy/tuscany/аvignonesi'},
                {
                    report: 'Azienda Agricola Casanova di Neri',
                    src: '/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri'
                },
                {report: 'Azienda Salvioni', src: '/wine-guide/italy/tuscany/azienda-salvioni'},
                {report: 'Castiglione del Bosco', src: '/wine-guide/italy/tuscany/castiglione-del-bosco'},
                {report: 'Conti Constani', src: '/wine-guide/italy/tuscany/conti-constani'},
                {report: 'Fattoria Le Pupille', src: '/wine-guide/italy/tuscany/fattoria-le-pupille'},
                {report: 'Fattoria Poggio di Sotto', src: '/wine-guide/italy/tuscany/fattoria-poggio-di-sotto'},
                {report: 'Fontodi', src: '/wine-guide/italy/tuscany/fontodi'},
                {report: 'Frescobaldi', src: '/wine-guide/italy/tuscany/frescobaldi'},
                {report: 'Gianfranco Soldera', src: '/wine-guide/italy/tuscany/gianfranco-soldera'},
                {report: 'Isole e Olena', src: '/wine-guide/italy/tuscany/isole-e-olena'},
                {report: 'Marchesi Antinori', src: '/wine-guide/italy/tuscany/marchesi-antinori'},
                {report: 'Podere Poggio Scalette', src: '/wine-guide/italy/tuscany/podere-poggio-scalette'},
                {report: 'Poderi Boscarelli', src: '/wine-guide/italy/tuscany/poderi-boscarelli'},
                {report: 'Tenuta dell’Ornellaia', src: '/wine-guide/italy/tuscany/tenuta-dell-ornellaia'},
                {report: 'Tenuta di Trinoro', src: '/wine-guide/italy/tuscany/tenuta-di-trinoro'},
                {report: 'Tenuta San Guido', src: '/wine-guide/italy/tuscany/tenuta-san-guido'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
